// import moment from 'moment';

import daySettingService from 'src/api/daySetting';

function Ctrl($scope, $q, alertService, sdkUtils) {
  $scope.loading = false;

  $scope.daySettingForm = {
    reservationRequestEnabled: true,
    guestlistEnabledInternally: true,
    guestlistEnabledExternally: true
  };

  $scope.loading = true;

  $q.resolve(daySettingService.findByIdAndVenueId($scope.currentDateUTC.format('x'), $scope.venueId))
    .then(result => {
      $scope.daySetting = result.data;

      $scope.daySettingForm.reservationRequestEnabled = $scope.daySetting.reservationRequestEnabled;
      $scope.daySettingForm.guestlistEnabledInternally = $scope.daySetting.guestlistEnabledInternally;
      $scope.daySettingForm.guestlistEnabledExternally = $scope.daySetting.guestlistEnabledExternally;
      $scope.daySettingForm.guestlistCutoff = $scope.daySetting.guestlistCutoff || null;

      $scope.loading = false;
    });

  $scope.save = function(form, $event) {
    if ($event) $event.preventDefault();

    if (!form.$valid) return;

    $scope.saving = true;

    const updates = {
      reservationRequestEnabled: $scope.daySettingForm.reservationRequestEnabled,
      guestlistEnabledInternally: $scope.daySettingForm.guestlistEnabledInternally,
      guestlistEnabledExternally: $scope.daySettingForm.guestlistEnabledExternally,
      guestlistCutoff: $scope.daySettingForm.guestlistCutoff
    };

    $q.resolve(daySettingService.updateByIdAndVenueId($scope.daySetting.id, $scope.venueId, updates))
      .then(result => {
        $scope.daySetting = result.data;

        $scope.saving = false;

        alertService.success('Settings Saved.');
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  };
}

Ctrl.$inject = [
  '$scope',
  '$q',
  'alertService',
  'jsSdk.utils'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/manageDaySettings/controller.js